<template>
  <div class="form-category">
    <div>
      <v-btn class="btn-add-category" :aria-label="$t('Выбор категории')" @click.native.stop="catdialog = true">
        <span class="pro-icon-add" aria-hidden="true"></span>
      </v-btn>
      <v-dialog v-model="catdialog" max-width="600">
        <v-card class="modal">
          <div class="modal-head">
            {{ $t("Выбор категории") }}
            <v-btn color="modal-close" :aria-label="$t('Закрыть')" @click.native="catdialog = false">
              <span class="pro-icon-close1" aria-hidden="true"></span>
            </v-btn>
          </div>
          <div class="modal-body">
            <v-select
              :items="npaDataArray.refCategory"
              item-value="id"
              item-text="transName"
              input="transName"
              v-model="category"
              persistent-hint
              outlined
              rounded
              dense
              @change="selectedCategories($event)"
            />
            <div class="categoryNpa">
              <div class="checkbox">
                <label v-for="item in selectBranchLaw" :key="item.id">
                  <input
                    type="checkbox"
                    :checked="isTagChecked(item.id)"
                    :value="item.id"
                    @change="fetchTags($event)"
                  />
                  {{ item.transName }}
                </label>
              </div>
            </div>
          </div>
        </v-card>
      </v-dialog>
    </div>
    <div class="tags">
      <div class="flexbox">
        <span class="tag" v-for="item in selectCategories" :key="item.id">
          {{ item.transName }}
          <span
            class="pro-icon-close"
            role="button"
            tabindex="0"
            :aria-label="$t('Удалить') + ': ' + item.transName"
            @click="deleteCategory(item.id)"
            @keyup.enter="deleteCategory(item.id)"
            @keyup.space="deleteCategory(item.id)"
          ></span>
        </span>
      </div>
      <div class="flexbox">
        <span class="tag" v-for="item in tags" :key="item.id">
          {{ item.transName }}
          <span
            class="pro-icon-close"
            role="button"
            tabindex="0"
            :aria-label="$t('Удалить') + ': ' + item.transName"
            @click="deleteTag(item.id)"
            @keyup.enter="deleteTag(item.id)"
            @keyup.space="deleteTag(item.id)"
          ></span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    npaDataArray: [],
    category: [],
    selectCategories: [],
    categoryBranchLaw: {},
    selectBranchLaw: [],
    tags: [],
    catdialog: false
  }),
  async mounted() {
    this.npaDataArray = await this.$store.dispatch('fetchNpaData')
  },
  methods: {
    selectedCategories(id) {
      const brachlaw = this.npaDataArray.categoryBranchLaw
      let categoriesList = []

      Object.keys(brachlaw).forEach((key) => {
        const categories = brachlaw[key].filter(
          (item) => item.category.id === id
        )
        categoriesList = [...categoriesList, ...categories]
      })

      this.selectBranchLaw = categoriesList

      //выбранн(-ая)(-ые) категория
      const isArrayContains = this.selectCategories.find(
        (item) => item.id === id
      )

      if (!isArrayContains) {
        const selectCategory = this.npaDataArray.refCategory.find(
          (item) => item.id === id
        )
        this.selectCategories.push(selectCategory)
      }
      this.$emit(
        'selectedCategories',
        this.selectCategories.map((item) => item.id)
      )
    },
    fetchTags({ target }) {
      const selectedId = target.value
      const isChecked = target.checked

      const tag = this.selectBranchLaw.find(
        (item) => Number(item.id) === Number(selectedId)
      )

      if (isChecked) {
        this.tags.push(tag)
      } else {
        this.tags = this.tags.filter(
          (item) => Number(item.id) !== Number(selectedId)
        )
      }
      this.sendBranchLaw()
    },
    isTagChecked(id, category) {
      const tagChecked = this.tags.filter(
        (item) => Number(item.id) === Number(id)
      )
      const tagCheckedCategory = this.tags.filter(
        (item) => Number(item.category) === Number(category)
      )

      return tagChecked.length > 0

      this.sendBranchLaw()
    },
    deleteTag(id) {
      this.tags = this.tags.filter((item) => Number(item.id) !== Number(id))
      this.sendBranchLaw()
    },
    deleteCategory(id) {
      this.selectCategories = this.selectCategories.filter(
        (item) => Number(item.id) !== Number(id)
      )
      this.$emit(
        'selectedCategories',
        this.selectCategories.map((item) => item.id)
      )
    },
    sendBranchLaw() {
      const BranchLawId = this.tags.map((item) => item.id)
      this.$emit('fetchTags', BranchLawId)
    }
  }
}
</script>
